import { routeFactory } from './index';
import { APPLICATION } from 'sh-www/models/application';

export default routeFactory(APPLICATION.SIMPLE_STATUS.PENDING, '/posting/:id/pending/');
